import {
  FETCH_ORDER_DETAILS_BEGIN,
  FETCH_ORDER_DETAILS_SUCCESS,
  FETCH_ORDER_DETAILS_FAILURE,
} from "../actions/orderActions";

const initialState = {
  orderDetails: [],
  loading: false,
  errors: null,
  request: null,
};

export default function orderDetailReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_ORDER_DETAILS_BEGIN:
      return {
        ...state,
        loading: true,
        errors: null,
        request: action.payload,
      };

    case FETCH_ORDER_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        orderDetails: action.payload.orderDetailResponse,
      };

    case FETCH_ORDER_DETAILS_FAILURE:
      return {
        ...state,
        loading: false,
        errors: action.payload.errors,
        orderDetails: [],
      };

    default:
      return state;
  }
}
